import * as React from "react"
import { Interval } from "@digits-graphql/frontend/graphql-bearer"
import { ToggleButtons, ToggleOption } from "@digits-shared/DesignSystem/FormElements/ToggleButtons"
import dateTimeHelper from "@digits-shared/helpers/dateTimeHelper"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { useDateRangeContext } from "src/shared/components/DateRangeSelector/DateRangeContext"

/*
  STYLES
*/
const IntervalsContainer = styled(ToggleButtons)`
  --toggle-buttons-background: ${colors.translucentSecondary05};
  --toggle-buttons-color: ${colors.secondary90};
  --toggle-buttons-selection-color: ${colors.secondary};
  --toggle-buttons-selection-background: ${colors.white};
  width: fit-content;
`

const IntervalOption = styled(ToggleOption)`
  text-transform: capitalize;
`

/*
  COMPONENTS
*/

export const IntervalSelector: React.FC = () => {
  const {
    dateRangeState: {
      timeRange: { interval },
    },
    dateRangeDispatch,
    intervals,
  } = useDateRangeContext()

  const onIntervalSelected = React.useCallback(
    (newInterval: Interval) => {
      dateRangeDispatch({ type: "SET_INTERVAL", interval: newInterval })
    },
    [dateRangeDispatch]
  )

  return (
    <IntervalsContainer defaultValue={String(interval)} onChange={onIntervalSelected}>
      {intervals[Interval.Day] && (
        <IntervalOption value={Interval.Day}>
          {dateTimeHelper.displayNameForInterval(Interval.Day)}
        </IntervalOption>
      )}

      {intervals[Interval.Month] && (
        <IntervalOption
          value={Interval.Month}
          onClick={onIntervalSelected.bind(undefined, Interval.Month)}
        >
          {dateTimeHelper.displayNameForInterval(Interval.Month)}
        </IntervalOption>
      )}

      {intervals[Interval.Quarter] && (
        <IntervalOption value={Interval.Quarter}>
          {dateTimeHelper.displayNameForInterval(Interval.Quarter)}
        </IntervalOption>
      )}

      {intervals[Interval.Year] && (
        <IntervalOption value={Interval.Year}>
          {dateTimeHelper.displayNameForInterval(Interval.Year)}
        </IntervalOption>
      )}
    </IntervalsContainer>
  )
}
